'use client'

import Link from '@/components/client/seo/link'
import { useTranslation } from '@/hooks/client'
import { tw } from '@/lib/utils'
import { localizedHref } from '@/lib/utils/localized-href'

// The fineprint sentence carries a {{privacyPolicy}} placeholder marking where
// the Privacy Policy link goes. We render the sentence verbatim and swap that
// placeholder for a real /privacy link, so the whole sentence stays in one
// translation key (word order and surrounding words included) instead of being
// split across keys. Editor-authored fineprint without the placeholder just
// renders as plain text — no link, no regression.
const PRIVACY_PLACEHOLDER = '{{privacyPolicy}}'

interface PrivacyFineprintProps {
  text: string
  className?: string
  linkClassName?: string
}

export const PrivacyFineprint = ({ text, className, linkClassName }: PrivacyFineprintProps) => {
  const { t, locale } = useTranslation()
  const [before, after] = text.split(PRIVACY_PLACEHOLDER)

  return (
    <span className={className}>
      {before}
      {after !== undefined && (
        <Link
          href={localizedHref(locale, '/privacy')}
          prefetch={false}
          data-tracking="ignore"
          className={tw('underline underline-offset-2 transition-colors hover:no-underline', linkClassName)}
        >
          {t('footer.privacyPolicy', 'Privacy Policy')}
        </Link>
      )}
      {after}
    </span>
  )
}
